// extracted by mini-css-extract-plugin
module.exports = {"root":"CardHeader_root__2Ha-K","title":"CardHeader_title__1ONw3"};